import { createReducer, on } from '@ngrx/store';

import {
	deleteAllReadUserNotifications,
	deleteUserNotifications,
	loadUnreadCount,
	loadUserNotifications,
	markAllUserNotificationsRead,
	markUserNotificationsRead,
	unreadCountLoaded,
	userNotificationsDeleted,
	userNotificationsDeletedAllRead,
	userNotificationsLoaded,
	userNotificationsMarkedAllRead,
	userNotificationsMarkedRead,
	userTaggedInCommentReceived
} from './user-notifications.actions';
import {
	IUserNotificationsState,
	initialUserNotificationsState
} from './user-notifications.state';

export const userNotificationsFeatureKey = 'userNotifications';

export const userNotificationsReducer = createReducer<IUserNotificationsState>(
	initialUserNotificationsState,

	on(loadUserNotifications, state => ({ ...state, loading: true })),
	on(userNotificationsLoaded, (state, { data }) => ({
		...state,
		loading:    false,
		items:      data?.records ?? [],
		totalCount: data?.totalCount ?? 0
	})),

	on(loadUnreadCount, state => state),
	on(unreadCountLoaded, (state, { data }) => ({
		...state,
		unreadCount: data
	})),

	on(markUserNotificationsRead, state => state),
	on(userNotificationsMarkedRead, (state, { data }) => {
		const ids = new Set(data);

		return {
			...state,
			items: state.items.map(item =>
				ids.has(item.id) ? { ...item, isRead: true } : item
			),
			unreadCount: Math.max(0, state.unreadCount - data.length)
		};
	}),

	on(markAllUserNotificationsRead, state => state),
	on(userNotificationsMarkedAllRead, state => ({
		...state,
		items:       state.items.map(item => ({ ...item, isRead: true })),
		unreadCount: 0
	})),

	on(deleteUserNotifications, state => state),
	on(userNotificationsDeleted, (state, { data }) => {
		const removed = state.items.find(item => item.id === data);

		if (!removed) {
			return state;
		}

		return {
			...state,
			items:       state.items.filter(item => item.id !== data),
			totalCount:  Math.max(0, state.totalCount - 1),
			unreadCount: removed.isRead
				? state.unreadCount
				: Math.max(0, state.unreadCount - 1)
		};
	}),

	on(deleteAllReadUserNotifications, state => state),
	on(userNotificationsDeletedAllRead, state => {
		const remaining = state.items.filter(item => !item.isRead);

		return {
			...state,
			items:      remaining,
			totalCount: Math.max(
				0,
				state.totalCount - (state.items.length - remaining.length)
			)
		};
	}),

	on(userTaggedInCommentReceived, state => ({
		...state,
		unreadCount: state.unreadCount + 1
	}))
);
